/**
 * Emergency auth storage cleaner
 * Call this if you have authentication issues due to stale tokens
 */
export const clearAllAuthStorage = () => {
    console.log('🧹 Clearing all authentication storage...');
    // Clear Zustand persist storage
    localStorage.removeItem('royal-gems-auth');
    sessionStorage.removeItem('royal-gems-auth');
    // Clear legacy token storage (if any)
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    sessionStorage.removeItem('accessToken');
    sessionStorage.removeItem('refreshToken');
    // Clear any debug data
    localStorage.removeItem('auth-debug-last-login');
    localStorage.removeItem('auth-debug-rehydration');
    localStorage.removeItem('auth-debug-final-state');
    console.log('✅ All authentication data cleared!');
    console.log('🔄 Please refresh the page and login again.');
};
// Add to window for emergency use in browser console
if (typeof window !== 'undefined') {
    window.clearAuthStorage = clearAllAuthStorage;
    console.log('💡 TIP: You can run window.clearAuthStorage() in the browser console to clear all auth data');
}
